import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {

  success = false;
  error = false;
  errorMsg: string;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.authService.removeTokenAndUserDetails();
  }

  ngOnInit(): void {
    this.activateAccount();
  }

  activateAccount() {
    this.loading = true;
    const email = this.route.snapshot.params.email;
    const token = this.route.snapshot.params.token;
    this.authService.activateAccount(email, token)
      .pipe(first())
      .subscribe(
        data => {
          if (data.success) {
            this.loading = false;
            this.success = true;
            return;
          }
          this.error = true;
          this.errorMsg = data.error.msg;
          this.loading = false;
        },
        error => {
          this.error = true;
          this.loading = false;
        }
      );
  }

}
